module.exports = __webpack_public_path__ + "media/public/fonts/QanelasMedium/QanelasMedium-c7345b05f2c2521c813700af2cbca8ad.eot";